import React from 'react'
import { HeatList } from "../helper/MenuList";
import MenuItem from '../components/MenuItem';
import '../styles/Heat.css'

function Heat() {
  return (
    <div className='heat'>
      <h1 className='heatTitle'>Extreme Heat</h1>
      <div className='heatList'>
        {HeatList.map((cardItem, key) => {
            return (
            <MenuItem 
                key={key}
                image={cardItem.image} 
                name={cardItem.name} 
                desc={cardItem.desc} />
            )
        })}
      </div>
    </div>
  )
}

export default Heat
